var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "radio-buttons" },
    _vm._l(_vm.items, function (item) {
      return _c("div", { key: item.id, staticClass: "radio-button" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.internalSelectedItem,
              expression: "internalSelectedItem",
            },
          ],
          staticClass: "radio-inline",
          attrs: { type: "radio", id: _vm.getInputId(item.id) },
          domProps: {
            value: item,
            checked: _vm._q(_vm.internalSelectedItem, item),
          },
          on: {
            change: [
              function ($event) {
                _vm.internalSelectedItem = item
              },
              _vm.onChange,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "radio-inline mr-3",
            attrs: { for: _vm.getInputId(item.id) },
          },
          [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }